// noinspection ES6ConvertVarToLetConst

var HubspotListsCtrl = function ($scope) {
    'use strict'

    $scope.getSelectedContactListKeys = function (ngModel) {
        if (ngModel == null) return ''

        const keys = ngModel
            .map(function (obj) {
                return obj.value && obj.value.key ? obj.value.key : obj.key
            })
            .filter(function (key, idx) {
                const el = document.getElementById('contactListValue[' + idx + ']')
                return key != null && el.value !== ''
            })
            .sort()
            .toString()

        return keys
    }

    return $scope
}

HubspotListsCtrl.$inject = ['$scope']
angular.module('app').controller('HubspotListsCtrl', HubspotListsCtrl);
